/**
 * Browser wrapper around the portable `@skjv/study-pdf` renderer. Passes in
 * the browser-side VerseTextSource (fetch + DOMParser) and looks up the
 * study group via bibleState. Returns a Blob for download / upload sidecars.
 */

import type { Study, StudyAiCommentary } from '@skjv/common';
import { generateStudyPdfBytes, generateCommentaryPdfBytes } from '@skjv/study-pdf';
import { bibleState } from '@/state/bible-state';
import { browserVerseTextSource } from './verse-text';

export async function generateStudyPdf(study: Study): Promise<Blob> {
  const studyGroup = bibleState.getStudyGroup(study.studyGroupId);
  const bytes = await generateStudyPdfBytes({
    study,
    studyGroup,
    verseTextSource: browserVerseTextSource,
  });
  return new Blob([bytes], { type: 'application/pdf' });
}

/** The commentary page alone — printed straight from the AI view. */
export async function generateCommentaryPdf(commentary: StudyAiCommentary): Promise<Blob> {
  const bytes = await generateCommentaryPdfBytes({
    commentary,
    verseTextSource: browserVerseTextSource,
  });
  return new Blob([bytes], { type: 'application/pdf' });
}
